import { Platform } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

export function useAndroidHeaderInset(): { headerStatusBarHeight?: number } {
  const insets = useSafeAreaInsets();
  if (Platform.OS !== 'android') return {};
  return { headerStatusBarHeight: insets.top };
}
